import { ReactNode, useEffect, useLayoutEffect, useState } from "react";
import AccessDeniedPage from "../pages/AccessDeniedPage";
import { useLocation } from "react-router-dom";
import {
  AuthContextValue,
  useAuth,
  useAuth as useRole,
} from "../providers/AuthProvider";
import InactiveUserPage from "../pages/InactiveUserPage";
import LoadingScreen from "../components/LoadingScreen";

interface IRoute {
  name: string;
  hasId: boolean;
}

// ROLE_MFI_OPERATION
const WithAuth = (OriginalComponent: any) => {
  const SHARED_PAGES: IRoute[] = [
    { name: "profile", hasId: false },
    { name: "users", hasId: true },
    { name: "changePassword", hasId: false },
    { name: "branches", hasId: false },
  ];

  const OWNERS_PAGES: IRoute[] = [
    ...SHARED_PAGES,
    { name: "sp-admin", hasId: false },
  ];
  const SUPPER_ADMIN_PAGES: IRoute[] = [
    ...SHARED_PAGES,
    { name: "admin", hasId: false },
    { name: "agronomy", hasId: false },
    { name: "lookup", hasId: false },
    { name: "inputs", hasId: false },
    { name: "inputs", hasId: true },
    { name: "orders", hasId: false },
    { name: "orders", hasId: true },
    { name: "products", hasId: false },
    { name: "products", hasId: true },
    { name: "users", hasId: false },
    { name: "all-users", hasId: false },
    { name: "organizations", hasId: false },
    { name: "organizations", hasId: true },
    { name: "warehouse", hasId: false },
    { name: "warehouse", hasId: true },
    { name: "farming-stage", hasId: false },
    { name: "input-price", hasId: false },
    { name: "output-price", hasId: false },
    { name: "branches", hasId: true },
    { name: "workLocations", hasId: false },
    { name: "workLocations", hasId: true },
  ];

  const SUPPER_SP_ADMIN: IRoute[] = [
    ...SHARED_PAGES,
    { name: "orders", hasId: false },
    { name: "orders", hasId: true },
    { name: "admin", hasId: false },
    { name: "contracts", hasId: false },
    { name: "contracts", hasId: true },
    { name: "customers", hasId: false },
    { name: "customers", hasId: true },
    { name: "voucher", hasId: false },
    { name: "voucher", hasId: true },
    // { name: "importCustomers", hasId: false },
    // { name: "importCustomers", hasId: true },
  ];

  const OFF_TAKER_ADMIN_PAGES: IRoute[] = [
    ...SHARED_PAGES,
    { name: "off-taker", hasId: false },
    { name: "my-orders", hasId: false },
    { name: "my-orders", hasId: true },
    { name: "branches", hasId: true },
    { name: "users", hasId: true },
    { name: "users", hasId: false },
    { name: "create-order", hasId: false },
    { name: "edit-order", hasId: true },
    { name: "products", hasId: false },
    { name: "products", hasId: true },
    { name: "uploadDocument", hasId: false },
    { name: "documents", hasId: false },
  ];

  const BANK_ADMIN_PAGES: IRoute[] = [
    ...SHARED_PAGES,
    { name: "bank", hasId: false },
    { name: "documents", hasId: false },
    { name: "contracts", hasId: false },
    { name: "contracts", hasId: true },
    { name: "customers", hasId: false },
    { name: "customers", hasId: true },
    { name: "voucher", hasId: false },
    { name: "voucher", hasId: true },
    { name: "redemptions", hasId: false },
    { name: "users", hasId: false },
    { name: "all-users", hasId: false },
    { name: "mfi", hasId: false },
  ];

  const BANK_OPERATION_PAGES: IRoute[] = [
    ...SHARED_PAGES,
    // { name: 'bank', hasId: false },
    // { name: 'documents', hasId: false },
    { name: "contracts", hasId: false },
    { name: "contracts", hasId: true },
    { name: "customers", hasId: false },
    { name: "customers", hasId: true },
    { name: "voucher", hasId: false },
    { name: "voucher", hasId: true },
    // { name: 'users', hasId: false },
    // { name: 'all-users', hasId: false },
    { name: "mfi", hasId: false },
  ];

  const INSURANCE_ADMIN_PAGES: IRoute[] = [
    ...SHARED_PAGES,
    { name: "insurance", hasId: false },
    { name: "documents", hasId: false },
    { name: "contracts", hasId: false },
    { name: "contracts", hasId: true },
  ];

  const AGRO_DEALER_ADMIN_PAGES: IRoute[] = [
    ...SHARED_PAGES,
    { name: "ad-dashboard", hasId: false },
    { name: "voucher", hasId: false },
    { name: "voucher", hasId: true },
    { name: "uploadDocument", hasId: false },
    { name: "documents", hasId: false },
    { name: "input-sales", hasId: false },
    { name: "users", hasId: false },
    { name: "redemption", hasId: false },
    { name: "redemptions", hasId: false },
  ];

  const AGRO_DEALER_OPERATION_PAGES: IRoute[] = [
    ...SHARED_PAGES,
    { name: "ad-dashboard", hasId: false },
    { name: "voucher", hasId: false },
    { name: "voucher", hasId: true },
    { name: "uploadDocument", hasId: false },
    { name: "input-sales", hasId: false },
  ];

  const AGRO_DEALER_STORE: IRoute[] = [
    ...SHARED_PAGES,
    { name: "redemption", hasId: false },
  ];

  const NewComponent = () => {
    const [route, setRoute] = useState<IRoute | undefined>();
    const { user, getUserByTolken } = useAuth() as AuthContextValue;
    const location = useLocation().pathname.substring(1);
    const [routeName, id] = location.split("/");
    const token = localStorage.getItem('token');

    const [loading, setLoading] = useState(true);

    useEffect(() => {
      const fetchUser = async () => {
        await getUserByTolken();
        setLoading(false);
      };
    
      if (token && !user) {
        fetchUser();
      } else {
        setLoading(false);
      }
    }, [token]);


useLayoutEffect(() => {
  if (!user) return;

  let _route;
  switch (user.roleName) {
    case "ROLE_SUPER_ADMIN":
      _route = OWNERS_PAGES.find(p => p.name === routeName && p.hasId === !!id);
      break;
    case "ROLE_KFT_SUPER_ADMIN":
      _route = SUPPER_ADMIN_PAGES.find(p => p.name === routeName && p.hasId === !!id);
      break;
    case "ROLE_KFT_SP_ADMIN":
      _route = SUPPER_SP_ADMIN.find(p => p.name === routeName && p.hasId === !!id);
      break;
    case "ROLE_OFF_TAKER_ADMIN":
      _route = OFF_TAKER_ADMIN_PAGES.find(p => p.name === routeName && p.hasId === !!id);
      break;
    case "ROLE_MFI_ADMIN":
    case "ROLE_MFI_OPERATION":
      _route = BANK_ADMIN_PAGES.find(p => p.name === routeName && p.hasId === !!id);
      break;
    case "INSURANCE_ADMIN":
      _route = INSURANCE_ADMIN_PAGES.find(p => p.name === routeName && p.hasId === !!id);
      break;
    case "ROLE_MPC_ADMIN":
    case "ROLE_KFT_SP_ADMIN":
      _route = AGRO_DEALER_ADMIN_PAGES.find(p => p.name === routeName && p.hasId === !!id);
      break;
    case "ROLE_MPC_OPERATION":
      _route = AGRO_DEALER_OPERATION_PAGES.find(p => p.name === routeName && p.hasId === !!id);
      break;
    case "MOB_ROLE_AGRO_DEALER":
      _route = AGRO_DEALER_STORE.find(p => p.name === routeName && p.hasId === !!id);
      break;
    default:
      if (routeName === "changePassword") {
        _route = { name: routeName, hasId: false };
      }
      break;
  }

  setRoute(_route);
}, [user]);

    

    if (!token || !user || loading) {
      return <LoadingScreen />;
    }
    
  
    if (!route) {
      return <AccessDeniedPage />;
    }
  
    if (
      user && user.isActive === 0 &&
      routeName !== "changePassword" &&
      ((user.roleName === "ROLE_OFF_TAKER_ADMIN" && route?.name !== "documents") ||
        (user.roleName === "BANK_ADMIN" && route?.name !== "documents") ||
        (user.roleName === "INSURANCE_ADMIN" && route?.name !== "documents") ||
        (user.roleName === "AGRO_DEALER_ADMIN" && route?.name !== "documents"))
    ) {
      return <InactiveUserPage />;
    }
  
    return <OriginalComponent />;
  };

  return NewComponent;
};

export default WithAuth;
